<!-- <app-sub-header [title]="'Telemedicine Consultation Detail'"></app-sub-header> -->
<!-- changes by naved comment the line -->

<div class="content">
  <div class="form-cont">
    <div class="row">
      <div class="col-xl-3 col-lg-4 col-md-5">
        <app-stickybar></app-stickybar>
      </div>

      <div class="col-xl-9 col-lg-8 col-md-7">
        <div class="card medi-consult-container" style="min-height: 955px">
          <div class="card-body pt-0">
            <div class="tab-content pt-0">
              <div id="pat_medicalrecords" class="tab-pane fade show active">
                <div class="main-content">
                  <div class="consultation-section">
                    <div
                      style="
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        padding: 0 10px;
                      "
                    >
                      <div style="display: flex; align-items: center">
                        <h1 class="medi-title">Booking Detail View</h1>
                      </div>
                      <button (click)="goBack()" class="back-btn button_class">
                        ← Back
                      </button>
                    </div>

                    <div>
                      <div class="booking-card">
                        <div class="user-section">
                          <div class="user-avatar">
                            <img
                              [src]="
                                stateData.user_profile
                                  ? stateData.user_profile
                                  : '../../../../../assets/Images/new-images/medical-checkup.webp'
                              "
                              alt="Kelly Joseph"
                            />
                          </div>
                          <div class="user-details">
                            <div class="user-id">
                              Booking ID : {{ stateData.tc_booking_id }}
                            </div>
                            <div class="user-name">
                              {{
                                stateData.user_first_name +
                                  " " +
                                  stateData.user_last_name
                              }}
                            </div>
                            <div class="user-contact">
                              <div class="phone">
                                📞 {{ stateData.phone_number }}
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="info-section">
                          <div class="info-row">
                            <div class="info-label">Doctor Name:</div>
                            <div class="info-value">
                              {{
                                stateData.doctor_first_name ||
                                stateData.doctor_last_name
                                  ? (stateData.doctor_first_name || "") +
                                    " " +
                                    (stateData.doctor_last_name || "")
                                  : "N/A"
                              }}
                            </div>
                          </div>
                          <div class="info-row">
                            <div class="info-label">Booking Date / Time:</div>
                            <div class="info-value">
                              {{
                                stateData?.booking_date &&
                                stateData.booking_date !== "N/A"
                                  ? (stateData.booking_date
                                    | date : "yyyy-MM-dd")
                                  : stateData?.createdAt
                                  ? (stateData.createdAt | date : "yyyy-MM-dd")
                                  : "N/A"
                              }}
                              /
                              {{
                                stateData?.booking_time &&
                                stateData.booking_time !== "N/A"
                                  ? stateData.booking_time
                                  : stateData?.createdAt
                                  ? (stateData.createdAt
                                    | date : "hh:mm a" : "Africa/Harare")
                                  : "N/A"
                              }}
                            </div>
                          </div>
                          <div class="info-row">
                            <div class="info-label">Consult Type:</div>
                            <div class="info-value">
                              {{ stateData.consultation_type }}
                            </div>
                          </div>
                          <div class="info-row">
                            <div class="info-label">
                              Reason for Consultation:
                            </div>
                            <div class="info-value">
                              {{
                                stateData?.reason_for_consultation &&
                                stateData.reason_for_consultation !== "USSD" &&
                                stateData.reason_for_consultation !== "IVR"
                                  ? stateData.reason_for_consultation
                                  : "N/A"
                              }}
                            </div>
                          </div>
                          <div class="info-row">
                            <div class="info-label">Channel:</div>
                            <div class="info-value">
                              {{
                                stateData?.channel_id === 1
                                  ? "Web"
                                  : stateData?.channel_id === 2
                                  ? "Ussd"
                                  : stateData?.channel_id === 3
                                  ? "Ivr"
                                  : stateData?.channel_id === 8
                                  ? "Manual"
                                  : "N/A"
                              }}
                            </div>
                          </div>
                          <div class="info-row">
                            <div class="info-label">Booking Status:</div>
                            <div class="info-value">
                              {{
                                ["MISSED", "REQUEST"].includes(
                                  stateData.tc_booking_status
                                )
                                  ? "Requested"
                                  : (stateData.tc_booking_status | titlecase)
                              }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
